/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class DeletedAccountEntity extends Entity {
  createdAt: string | null = null;
  deletedAt: string | null = null;
  id: string = '';
  integrationId: string | null = null;
  salesforceId: string | null = null;
  updatedAt: string | null = null;
  static override key = 'DeletedAccount';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'DeletedAccount' in input
    ) {
      const { DeletedAccount: wrapped, ...rest } = input as {
        DeletedAccount: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}